import { render } from "./MasterLayout.vue?vue&type=template&id=7ff0b27c"
import script from "./MasterLayout.vue?vue&type=script&lang=js"
export * from "./MasterLayout.vue?vue&type=script&lang=js"
script.render = render

export default script